import { Result } from 'journeys/portal/Forms/Sections.constants';
import { labelWidth } from '../../../HMISection/Data/P710/P710.data';
import { AsFoundResultP51, healthBarrierReportFormula, TestAsFoundResultValue, TestResultDropdownOptions } from './P51.formulas';

export const TestResultSectionDataP51 = (selectedTag, formData, formName) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F1092HealthBarrierReport',
                    label: 'Barrier Health',
                    value: healthBarrierReportFormula(formData),
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    readOnly: true,
                    isCalculatedNew: true,
                    width: '71.5%',
                    marginLeft: '4px',
                    height: '1.25rem',
                    textAlign: 'center',
                    textAlignLabel: 'left',
                },
                {
                    key: 'F102AftResult',
                    label: Result.AS_FOUND_RESULT_LABEL,
                    value: AsFoundResultP51(formData),
                    xs: 6,
                    isCalculatedNew: true,
                    readOnly: true,
                    marginRight: '0.5rem',
                    direction: 'rtl',
                    height: '1.4rem',
                    labelWidth: '100%',
                    borderBottom: '0',
                    width: '71.5%',
                    textAlign: 'center',
                    textAlignLabel: 'right',
                }
            ]
        },
        {
            key: 2,
            fields: [
                {
                key: 'Nodata',
                isLabel: true,
                xs: 2,
            },
            {
                key: 'Nodata',
                isLabel: true,
                xs: 2,
            },
            {
                key: 'Nodata',
                isLabel: true,
                xs: 2,
            },
                {
                    key: 'F85TestResultLabel',
                    label: 'Test Result Action',
                    xs: 2,
                    labelWidth,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                    textAlign: 'right',
                },
                {
                    key: 'F85TestResult',
                    value: TestAsFoundResultValue(formData) ? '' : formData.F85TestResult,
                    isRequired: true,
                    isDropDown: true,
                    placeholder: 'Select Test Result',
                    options: TestResultDropdownOptions(formData),
                    xs: 4,
                    labelWidth: '0',
                    width: '100%',
                    marginLeft: 'auto',
                }
            ]
        }
    ]
});
